import { gql } from "@apollo/client";
import { Button, ButtonGroup, darken, lighten, Paper } from "@mui/material";
import { ButtonBase } from "@mui/material";
import DateTime from "atoms/DateTime";
import Stack from "atoms/Stack";
import { COLOR_BLACK, COLOR_BLACK_LIGHTER, COLOR_WHITE } from "helpers/colors";
import { FONT_FAMILY_GRAPHIK } from "helpers/FONT";
import PotwVideoPlayerDialog from "pages/video_player/PotwVideoPlayerDialog";
import React, { useState } from "react";

export const PotwCompetitionCardFragment = gql`
  fragment PotwCompetitionCardFragment on PotwCompetition {
    id
    competitionType
    name
    completed
    startDate
    endDate
    org {
      id
      name
    }
    videoUrl
  }
`;

export default function PotwCompetitionCard({ potwCompetition }) {
  const [dialogOpen, dialogOpenSet] = useState(false);
  const colorDarken = darken(COLOR_BLACK, 0.5);
  const colorLighten = lighten(COLOR_BLACK_LIGHTER, 0.8);

  return (
    <>
      <PotwVideoPlayerDialog
        open={dialogOpen}
        onClose={() => dialogOpenSet(false)}
        potwCompetitionId={potwCompetition.id}
      />
      <Paper
        elevation={10}
        style={{
          borderRadius: 10,
          overflow: "hidden",
          display: "flex",
          flexFlow: "column nowrap",
          justifyContent: "stretch",
        }}
      >
        <Stack
          noGap
          style={{
            flex: "1 1 auto",
            background: `linear-gradient(130deg, ${COLOR_BLACK_LIGHTER}, ${colorDarken})`,
            color: COLOR_WHITE,
            fontWeight: 500,
            fontFamily: FONT_FAMILY_GRAPHIK,
            fontSize: 12,
          }}
        >
          <Stack
            padding
            element={<ButtonBase href={`/potw/competitions/${potwCompetition.id}`} />}
            horizontal
            alignItemsStart
            style={{
              flex: "1 1 auto",
              textTransform: "uppercase",
            }}
          >
            <div style={{ minWidth: 0, overflow: "hidden" }}>
              <div style={{ fontSize: "1.6em", marginBottom: "5px" }}>{potwCompetition.name}</div>
              <div
                style={{
                  textOverflow: "ellipsis",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                }}
              >
                {potwCompetition.org.name}
              </div>
            </div>
          </Stack>
          <Stack
            padding
            dense
            alignItemsCenter
            style={{
              fontSize: ".8em",
              color: COLOR_WHITE,
            }}
          >
            {!potwCompetition.completed && (
              <div>
                Voting closes <DateTime value={potwCompetition.endDate} variant="short_date" />
              </div>
            )}
          </Stack>
        </Stack>
        <ButtonGroup variant="text" fullWidth>
          <Button
            href={`/potw/competitions/${potwCompetition.id}`}
            style={{
              fontFamily: FONT_FAMILY_GRAPHIK,
              fontSize: 12,
              color: COLOR_BLACK,
              flex: 1,
              borderColor: colorLighten,
            }}
          >
            {potwCompetition.completed ? <>Watch Entries</> : <>Vote Now</>}
          </Button>
          {potwCompetition.videoUrl && (
            <Button
              onClick={() => dialogOpenSet(true)}
              sx={{
                fontFamily: FONT_FAMILY_GRAPHIK,
                fontSize: 12,
                flex: 1,
                color: COLOR_BLACK,
              }}
            >
              Watch Top 5
            </Button>
          )}
        </ButtonGroup>
      </Paper>
    </>
  );
}
